import { NotificationType } from "../../enums/notification-type-enum";
import { BaseSearchModel } from "../query/base-search.model";

export class NotificationsSearchModel extends BaseSearchModel {
    skip?: boolean;
    isRead?: boolean; 
    createdById?: string; 
    notificationId?: string; 
    type?: NotificationType; 
}
